import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { configureVerification, configureSessionExpiry } from '../config/axiosConfig';
import walletReducer from './slices/walletSlice';
import authReducer from './slices/authSlice';
import adminReducer from './slices/adminSlice';
import deliveryReducer from './slices/deliverySlice';
import paymentReducer from './slices/paymentSlice';
import driverReducer from './slices/driverSlice';
import {withDriverAccountIsolation,withAccountRequestGuard} from './driverAccountIsolation';

export const store = configureStore({
  reducer: withDriverAccountIsolation(combineReducers({
    wallet: walletReducer,
    admin: adminReducer,
    auth: authReducer,
    delivery: withAccountRequestGuard(deliveryReducer,'delivery'),
    payment: paymentReducer,
    driver: driverReducer,
  })),
});

configureVerification(
  (code) => store.dispatch({ type: code === 'EMAIL_NOT_VERIFIED' ? 'auth/requireEmailVerification' : 'auth/requirePhoneVerification' }),
  () => store.getState().auth.user
);

configureSessionExpiry(() => store.dispatch({ type: 'auth/logout' }));

export default store;
